import styled from 'styled-components';
import { getTypographyOptions } from '@optimus-web/core';

/** @description Avoid using this component by using preexisting typographical components that all share the same options if possible. */
export const TypographyOptions = styled.span`
    ${getTypographyOptions}
`;
